/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FraisParcConfigItemDto } from './FraisParcConfigItemDto';
import {
    FraisParcConfigItemDtoFromJSON,
    FraisParcConfigItemDtoFromJSONTyped,
    FraisParcConfigItemDtoToJSON,
    FraisParcConfigItemDtoToJSONTyped,
} from './FraisParcConfigItemDto';

/**
 * Configuration parc de l'ensemble des frais du tunnel.
 * @export
 * @interface GetFraisParcConfigResponse
 */
export interface GetFraisParcConfigResponse {
    /**
     * 
     * @type {Array<FraisParcConfigItemDto>}
     * @memberof GetFraisParcConfigResponse
     */
    items?: Array<FraisParcConfigItemDto>;
}

/**
 * Check if a given object implements the GetFraisParcConfigResponse interface.
 */
export function instanceOfGetFraisParcConfigResponse(value: object): value is GetFraisParcConfigResponse {
    return true;
}

export function GetFraisParcConfigResponseFromJSON(json: any): GetFraisParcConfigResponse {
    return GetFraisParcConfigResponseFromJSONTyped(json, false);
}

export function GetFraisParcConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFraisParcConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(FraisParcConfigItemDtoFromJSON)),
    };
}

export function GetFraisParcConfigResponseToJSON(json: any): GetFraisParcConfigResponse {
    return GetFraisParcConfigResponseToJSONTyped(json, false);
}

export function GetFraisParcConfigResponseToJSONTyped(value?: GetFraisParcConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(FraisParcConfigItemDtoToJSON)),
    };
}

